'use client';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import React from 'react';

const File = ({
  variant,
  className,
  endContent,
  placeholder,
}: {
  variant?: 'outline';
  className?: string;
  endContent?: React.ReactNode;
  placeholder?: string;
}) => {
  const [file, setFile] = React.useState<File | null>(null);

  const handleClick = () => {
    ref.current?.click();
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      setFile(e.target.files[0]);
    }
  };

  const handleClear = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    setFile(null);
    (ref.current as { value: string }).value = '';
  };

  const ref = React.useRef<HTMLInputElement>(null);
  return (
    <div
      className={clsx('hover:opacity-80 transition-opacity', className)}
      onClick={handleClick}
    >
      <input className="hidden" type="file" ref={ref} onChange={handleChange} />

      <div className="flex items-center justify-between h-12 border border-gray-light2 rounded-extra cursor-pointer px-3">
        {file ? (
          <span className="body2 text-dark">{file.name}</span>
        ) : (
          <span className="body2 text-gray-lighter">{placeholder}</span>
        )}
        {file ? (
          <div
            className="p-0 cursor-pointer w-[22px] h-[22px] hover:bg-black/10 rounded-full transition-background flex items-center justify-center"
            onClick={handleClear}
          >
            <FontAwesomeIcon icon="xmark" />
          </div>
        ) : (
          endContent
        )}
      </div>
    </div>
  );
};

export default File;
